import { render, staticRenderFns } from "./DevPanel.vue?vue&type=template&id=2e9703b7&scoped=true&"
import script from "./DevPanel.vue?vue&type=script&lang=js&"
export * from "./DevPanel.vue?vue&type=script&lang=js&"
import style0 from "./DevPanel.vue?vue&type=style&index=0&id=2e9703b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9703b7",
  null
  
)

export default component.exports